import React, { useState, useEffect } from 'react'
import { Route, Routes,useSearchParams } from "react-router-dom";
import Admin from './layouts/Admin';
import Login from './pages/Login';
import { userSessionContext } from "../src/components/user-context";
import { useNavigate } from "react-router-dom";
import AppGuide from "./pages/AppGuide"
import { apiUrl } from "./commons/inFormTypes";
import ClearCache from 'react-clear-cache';
import { CLOSING } from 'ws';
import LoginAmirkola from './pages/LoginAmirkola';// for amirkola and mahmoodabad you should use "LoginAmirkola"
import SMSFormPayment from './components/SMSFormPayment';

const App: React.FC<{}> = () => {
  // const { isLatestVersion, emptyCacheStorage } = useClearCache();
  const GUEST_USER = { Islogin: false, displayName: 'نام کاربر' }
  const [user, setUser] = useState(GUEST_USER);
  const [title, setTitle] = useState();
  const [typeLogin,setTypeLogin] = useState(1)
  const userToken = localStorage.getItem("user_token");
  const [searchParams, setSearchParams] = useSearchParams();
  const promptId2 = searchParams.get('Usertoken');
  const navigate = useNavigate();
  const axios = require("axios");


  const logIn = (name) => {
    setUser({ Islogin: true, displayName: name })
  }

  const logOut = () => {
    localStorage.removeItem("user_token");
    localStorage.clear();
    setUser(GUEST_USER)
    navigate("/")
  }

  useEffect(() => {
    if (userToken == null && promptId2 === null) {
     // navigate("/");
    } else {
      axios({
        method: "post",
        url: apiUrl + "userinfo",
        headers: {
          'Access-Control-Allow-Origin': "*",
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + userToken,
        }
      })
        .then((res) => {
          if (res.data.success) {
            navigate("/admin/dashboard");
          }
        })
        .catch(function (error) {
          console.log(error);
        });       
    }

    axios({
      method: "get",
      url: apiUrl + "settings",
      headers: {},
    }).then((res) => {
      setTitle(res.data.data.title);
      setTypeLogin(res.data.data.theme);
      document.title= res.data.data.title
    }); 
  }, []);


// !isLatestVersion
  return (
    // <ClearCacheProvider  auto={false}>
    <ClearCache>
      {({ loading, latestVersion, isLatestVersion, emptyCacheStorage }) =>
      <userSessionContext.Provider value={{ user, logIn, logOut }}>
      <div>
        <Routes>
          <Route path="/" element={typeLogin === 1 ? <LoginAmirkola/> : <Login/>} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path='appguide' element={<AppGuide />} />
          <Route path='sMsformpayment' element={<SMSFormPayment />} />
        </Routes>
      </div>
    </userSessionContext.Provider>
}
    </ClearCache>
   
    // </ClearCacheProvider>
  )
}

export default App;
